<template>
  <div>
    <!-- 热门评量工具 -->
    <div class="rank-table">
      <dv-scroll-board :config="tableData" class="scroll-board" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rankData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tableData: {}
    };
  },
  watch: {
    rankData: {
      handler() {
        this.init();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    init() {
      this.tableData = {
        header: ['类型', '数量', '排名'],
        data: this.rankData,
        headerHeight: '70',
        align: ['center', 'center', 'center']
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.rank-table {
  width: 100%;
  height: 435px;
  padding: 10px;
  // background-image: url(~@/assets/images/table-bg.png);
  // background-size: 100% 100%;
  .scroll-board {
    ::v-deep {
      .header {
        background-color: transparent !important;
        font-size: 24px;
        font-weight: 500;
        color: #ffcc00;
      }
      .rows {
        .row-item {
          font-weight: 300;
          font-size: 20px;
          background-color: transparent !important;
        }
        .row-item:nth-child(odd) {
          box-shadow: inset 0px 0px 10px 0px #fff;
        }
      }
    }
  }
}
</style>